'use client';

import Script from 'next/script';
import { useEffect } from 'react';
import useDeferredMount from '@/utils/useDeferredMount';

export default function AngelAiWidget() {
  const ready = useDeferredMount();

  useEffect(() => {
    if (!ready) return;

    const loadCSS = () => {
      const link = document.createElement('link');
      link.id = 'angelai-widget-styles';
      link.rel = 'stylesheet';
      link.href = process.env.NEXT_PUBLIC_ANGELAI_WIDGET_CSS;
      document.head.appendChild(link);
    };
    loadCSS();

    const labelSearchInput = () => {
      const textarea = document.getElementById('search');
      if (textarea && !textarea.getAttribute('aria-label')) {
        textarea.setAttribute('aria-label', 'Ask AngelAi');
      }
    };
    labelSearchInput();
    const observer = new MutationObserver(labelSearchInput);
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, [ready]);

  if (!ready) return null;

  return (
    <>
      <div id="mini-Morgan-chat-widget" />
      <Script
        id="angelai-widget"
        src={process.env.NEXT_PUBLIC_ANGELAI_WIDGET_JS}
        strategy="lazyOnload"
        comicBubbleBackground="#ffffffe6"
        comicBubbleBorderColor="#FF541C60"
        userType="angelailife"
        onLoad={() => {
          if (typeof window !== 'undefined' && window.mmc) {
            window.mmc(350, 430, 'left', 10, 10, 999);
          }
        }}
      />
    </>
  );
}
